import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

export interface User {
  id: number;
  identifier: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  enabled: boolean;
  organizationId: number;
  organizationName: string;
  rolesAsStrings: string[];
  roles: Role[];
  role: Role;
  rolesToRemove: Role[];
  created: string;
  createdBy: string;
  updated: string;
  updatedBy: string;
  highlight: BehaviorSubject<boolean>;
  departmentRestrictionIds: number[];
  departmentRestrictionNames: string[];
}

export interface Role {
  id: string;
  name: string;
  description: string;
}

export class UserSearchEvent {
  organizationId?: number;
  roleName?: string;
  query?: string;
  includeDisabled = false;
  paging = new PageEvent();
  sorting: Sort | null = null;
}

export interface UserDepartmentResponse {
  id: number;
  name: string;
}
